import React from "react";
import SaveButton from "../../../components/SaveButton";
import CancelButton from "../../../components/CancelButton";
import ProducerAddressTable from "./ProducerAddressTable";
import ConfirmBoxModal from "../../../components/ConfirmBoxModal";
import { useSFGetOffice } from "../OfficeSettings/hooks/useSFGetOffice";
import { useLobTypeOptions } from "./hooks/useLobTypeOptions";
import { useDistributionChannelOptions } from "./hooks/useDistributionChannelOptions";
import { accountAtom } from "../../Login/atoms/AccountAtom";
import { useRecoilValue } from "recoil";
const AddProducersForm = ({
  data,
  Cancel,
  handleTextBoxChange,
  handleMultiStateSelect,
  handleRemovecarrierAddress,
  handleAddcarrierProducerCodeRow,
  handleProducerCodeInputs,
  carrierProducerCodeData,
  handleAddProducerCodeRow,
  handleRemoveProducerCodeRow,
  carrierContactTypes,
  addStatus,
  handleClickSave,
  saveDisabled,
  addMainForm,
  clearAddForm,
  handleMACheckBox,
  handleIsFranchise,
  saveModal,
  setSaveModal,
  buttonText,
}) => {
  const { data: agenciesQuery } = useSFGetOffice();
  const agencies =
    agenciesQuery &&
    agenciesQuery
      .filter((x) => x.officeCode !== null && x.officeCode !== "")
      .map((resData) => ({
        label: resData.officeName + "-" + resData.officeCode,
        value: resData.officeCode + "-" + resData.storeNumber,
        state: resData.stateCode,
      }));
  const user = useRecoilValue(accountAtom);
  const { data: LOBQuery } = useLobTypeOptions();
  const loboptions =
    LOBQuery &&
    LOBQuery.filter((data) => data.isActive === true).map((resData) => ({
      label: resData.lobname,
      value: resData.lobid,
    }));
  const { data: distChannelQuery } = useDistributionChannelOptions();
  const distChannelOpts =
    distChannelQuery &&
    distChannelQuery
      .filter(
        (dist) =>
          dist.isActive === true &&
          (user?.isNonFranchise && user?.isFranchise
            ? dist.distributionChannelName !== null
            : user?.isFranchise
            ? dist.distributionChannelName !== null
            : dist.distributionChannelName !== "Franchise")
      )
      .map((data) => ({
        label: data.distributionChannelName,
        value: data.distributionChannelId,
      }));

  return (
    <div className="w-full ">
      <div className="animate-fade-in-down1 rounded-2xl border-primary border-l-6 m-3 p-3 box-shadow text-sm">
        <div className="flex flex-row  justify-between items-center text-quinary font-bold font-sans text-lg pb-1">
          <div className="text-base text-primary font-bold">
            Add Producer Codes
          </div>
          <div className="flex justify-between gap-2">
            <SaveButton
              className={saveDisabled ? "opacity-50" : "opacity-100"}
              onClick={() => setSaveModal(true)}
              disabled={saveDisabled}
              buttonText={buttonText}
            />
            <CancelButton buttonText="Cancel" onClick={Cancel} />
          </div>
        </div>
        <div className="mt-2 h-1 w-full border-b-4 border-secondary"></div>
        <div className="-mt-8 text-xs flex items-center space-x-4 w-full">
          <div className="w-full">
            <div className="flex flex-row text-primary items-center font-bold  mb-2 gap-4">
              <div>Carrier:</div>
              <label className="text-quinary font-bold font-sans text-base uppercase">
                {data.carrierName}
              </label>
            </div>
            <div className="text-xs text-red-500 italic font-semibold mt-3">
              <b> Note: </b> All fields with * are required to fill.
            </div>
          </div>
          <div className="w-full"></div>
        </div>

        <div className="mt-4 ">
          <ProducerAddressTable
            tableName="ProducerAddressTable"
            hideActionColumn={false}
            addStatus={addStatus}
            agencies={agencies}
            data={data}
            state={data.state}
            carrierProducerCodeData={carrierProducerCodeData}
            handleMultiSelect={handleMultiStateSelect}
            carrierContactTypes={carrierContactTypes}
            handleAddcarrierProducerCodeRow={handleAddcarrierProducerCodeRow}
            handleRemovecarrierAddress={handleRemovecarrierAddress}
            handleProducerCodeInputs={handleProducerCodeInputs}
            handleAddProducerCodeRow={handleAddProducerCodeRow}
            handleRemoveProducerCodeRow={handleRemoveProducerCodeRow}
            handleTextBoxChange={handleTextBoxChange}
            loboptions={loboptions}
            distChannelOpts={distChannelOpts}
            addMainForm={addMainForm}
            clearAddForm={clearAddForm}
            handleMACheckBox={handleMACheckBox}
            handleIsFranchise={handleIsFranchise}
          />
        </div>
      </div>

      <div className="hidden sm:block" aria-hidden="true"></div>
      <ConfirmBoxModal
        ModalTitle="Add Producer"
        qConfirmation=" Are you sure you want to add this data?"
        isOpen={saveModal}
        onClose={() => setSaveModal(false)}
        onClickFunction={() => handleClickSave()}
      />
    </div>
  );
};

export default AddProducersForm;
